import { render, staticRenderFns } from "./ErrorDialogue.vue?vue&type=template&id=8a7bd6ba&lang=true&"
import script from "./ErrorDialogue.vue?vue&type=script&lang=js&"
export * from "./ErrorDialogue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports